<template>
    <div style="text-align: center; ">
        <div>
            <div style="font-size: 32px; font-weight: 700; line-height: 46px;">이름을 알려주세요</div>
            <div style="margin-top: 16px;">
                <div>
                    <input v-model="name" @input="detectText" class="common_input" placeholder="본명을 입력하세요" type="text">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { REGIST_STEP } from '@/Constants';

export default {
    name: 'SignupName',
    props: {
        detectText: {
            type: Function,
            default: () => { }
        },
        mode: {
            type: String,
            default: 'insert'
        },
        registInfo: {
            type: Object,
            default: () => {}
        },
        setActiveBtn: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            name: '',
        }
    },
    methods: {

    },
    created() {
        console.log(this.mode)
        if (this.mode === 'update') {
            this.name = this.registInfo.name;
            if (this.name) {
                this.setActiveBtn()
            }
        }
    }
}
</script>

<style scoped>
.common_input {
    width: 310px;
    height: 56px;
    outline: none;
    border-radius: 12px;
    border: none;
    padding: 0 12px;
}

.common_input::placeholder {
    font-size: 20px;
    font-weight: 500;
    color: #bbbbbb;
}
</style>